import { CountriesGridView } from '~/components/system/countries';
import { PageContainer } from '~/components/page-container';

export function Countries() {
	return (
		<PageContainer>
			<CountriesGridView />
		</PageContainer>
	);
}
